module.exports = __webpack_public_path__ + "static/impact_title-fc6562e8cb53d0bc139c2b1bb96a8339.png";